
export default class StringUtils {

  /**
   * Compares two string arrays for set quality.
   * - Order-independant
   * - Ignore case
   * - Ignore whitespace
   *
   * @param left Left hand side of the comparison.
   * @param right Right hand side of the comparison.
   * @returns True if the two arrays contain the same elements, false otherwise.
   */
  static areSameStringSets(left: string[] = [], right: string[] = []): boolean {
    // Early exit if lengths differ
    if (left.length !== right.length) {
      return false;
    }

    // Normalizes values to ensure case- and whitespace-insensitive comparison
    const normalize = (value: string) => value.trim().toUpperCase();

    const rightSet = new Set(right.map(normalize));

    // Early exit if normalization collapses duplicates differently
    if (rightSet.size !== left.length) {
      return false;
    }

    // Ensure every normalized left value exists in the right set
    for (const value of left) {
      if (!rightSet.has(normalize(value))) {
        return false;
      }
    }

    return true;
  }

}
